const getValidationMessage = (
  validations: Validation | Validation[],
  key?: string,
  failed_object_id?: number | string,
): string => {
  if (!Array.isArray(validations)) {
    return getMessage(validations);
  }

  const validation = validations.find((v) => v.validation_id === key);

  if (!validation) return '';

  if (validation.validation_outcome === 'error') return '';

  if (
    failed_object_id &&
    !validation.failed_objects.includes(failed_object_id as any)
  ) {
    return '';
  }

  return getMessage(validation);
};

const getMessage = (validation: Validation) => {
  return validation.validation_outcome !== 'pass'
    ? `(${validation.validation_id}) ${validation.validation_name} : ${validation.validation_message}`
    : '';
};

export default getValidationMessage;
